module.exports = __webpack_public_path__ + "static/logo-lam-research-e0f4fd5349fa6916d9e5e41b173573f5.png";